import env from '../config/env';
import { postBodyService } from "./base.service";
import config from "../config/application";
import permission from "./permissions.service";
import dictionary from "../config/dictionary";

//url
const find = "operationsMonitor/find";
const findAll = "operationsMonitor/all";
const exportAll = "operationsMonitor/export";
const count = "operationsMonitor/count";
const sendPayment = "serviceSap/sendPayment";
const totalUrl = "operationsMonitor/sum";

class MonitorService {
  async getAllDataMonitor(json, username) {
    let valid = await permission.validPermission(
      env.transaction.monitor,
      username,
      env.app.systemCode,
      dictionary.configApp.action.list
    );
    if (valid.response === undefined && valid.data.allow === true) {
      const url = `${config.data.income.monitor.url}${findAll}`;
      return postBodyService(url, json);
    } else {
      return valid;
    }
  }

  async getAllDataMonitorExport(json, username) {
    let valid = await permission.validPermission(
      env.transaction.monitor,
      username,
      env.app.systemCode,
      dictionary.configApp.action.list
    );
    if (valid.response === undefined && valid.data.allow === true) {
      const url = `${config.data.income.monitor.url}${exportAll}`;
      return postBodyService(url, json);
    } else {
      return valid;
    }
  }

  async findDataMonitor(json, username) {
    let valid = await permission.validPermission(
      env.transaction.monitor,
      username,
      env.app.systemCode,
      dictionary.configApp.action.list
    );

    if (valid.response === undefined && valid.data.allow === true) {
      const url = `${config.data.income.monitor.url}${find}`;
      return postBodyService(url, json);
    } else {
      return valid;
    }
  }
  async countDataMonitor(json, username) {
    let valid = await permission.validPermission(
      env.transaction.monitor,
      username,
      env.app.systemCode,
      dictionary.configApp.action.list
    );

    if (valid.response === undefined && valid.data.allow === true) {
      const url = `${config.data.income.monitor.url}${count}`;
      return postBodyService(url, json);
    } else {
      return valid;
    }
  }
  async getTotal(json) {
    const url = `${config.data.income.monitor.url}${totalUrl}`;
    return postBodyService(url, json);
  }
  sendPayment(lsData) {
    const url = `${config.data.sap.serviceSap.url}${sendPayment}`;
    return postBodyService(url, lsData);
  }
}
export default new MonitorService();
